// Registers the offline service worker (public/sw.js) once the page has
// loaded. Silently no-ops in browsers/environments without SW support
// (e.g. some in-app webviews) instead of throwing.
export function registerServiceWorker() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    });
  }
}
